import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<React.StrictMode><App /></React.StrictMode>);

// PWA service worker registration
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js")
      .then(reg => {
        // Auto-update: check for new SW every 60s while tab is open
        setInterval(() => reg.update().catch(() => {}), 60_000);
        reg.addEventListener("updatefound", () => {
          const newSw = reg.installing;
          if (!newSw) return;
          newSw.addEventListener("statechange", () => {
            if (newSw.state === "installed" && navigator.serviceWorker.controller) {
              // New version ready — reload once to activate
              newSw.postMessage({ type: "SKIP_WAITING" });
              // Force reload after brief delay to pick up new SW
              setTimeout(() => window.location.reload(), 500);
            }
          });
        });
      })
      .catch(err => console.warn("SW registration failed:", err));
  });
}
